import React from 'react'

const BraceletsBangles = () => {
  return (
    <div>BraceletsBangles</div>
  )
}

export default BraceletsBangles